/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestAccountDelete.defs'
export { main as default } from './requestAccountDelete.defs'
